import React from "react";
// import Link from "next/link";
import { linkContext } from "app/links/linkContext";

interface Props {
    href: string;
    children: React.ReactNode;
    rel?: string;
    target?: string;
    className?: string;
    title?: string;
    id?: string;
}

/**
 * This renders an anchor tag that should link to a page.
 * The link component will preload any data necessary for the target page.
 *
 * The component also honors the LinkContext and will set its link target accordingly.
 */
export const DynamicLink = ({ href, children, className, title, id, rel, target }: Props) => {
    const context = React.useContext(linkContext);
    if (!target) {
        target = context.target;
    }
    return (
        /*<Link href={href}>*/
        <a href={href} rel={rel} className={className} target={target} title={title} id={id}>
            {children}
        </a>
        /*</Link>*/
    );
};
